import type { AnchorHTMLAttributes, MouseEventHandler, ReactNode } from 'react';

import { clinicSettings } from '@/data/clinic';
import { trackPhoneClick } from '@/features/analytics/googleTag';

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  children?: ReactNode;
};

const ClinicPhoneLink = ({ children = clinicSettings.phone.display, onClick, ...props }: Props) => {
  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    onClick?.(event);

    if (!event.defaultPrevented) {
      const navigationDelayed = trackPhoneClick(clinicSettings.phone.href);

      if (navigationDelayed) {
        event.preventDefault();
      }
    }
  };

  return (
    <a {...props} href={clinicSettings.phone.href} onClick={handleClick}>
      {children}
    </a>
  );
};

export default ClinicPhoneLink;
